module.exports = __webpack_public_path__ + "img/productSatellite_28.71a0e341.png";